import { PermissionsCategory } from "src/app/auth/permissions";

@PermissionsCategory("DisputeResolutionPermissions")
export class DisputeResolutionPermissions {
    static readonly None = 0;
    static readonly Upload = 1;
    static readonly EditData = 2;
}
